<template>
  <div id="Breadcrumbs">
    <a href="/">home</a> &gt; 
    <a :href="base.url" class="breadcrumb-1">{{base.title}}</a>
   <template v-for='route in routes'>
      &gt;
      <a v-if='"href" in route'>{{route.title}}</a>
      <router-link v-else :to='route'>{{route.title}}</router-link>
      
    </template>
  </div>
</template>

<script>
export default {
  props: ['base', 'current'],
  computed: {
    routes() {
      let matched = this.$route.matched;
      let ret = [];

      for (let i = 0; i< matched.length; i++) {
        if ("default" in matched[i].instances) {
          if ("breadcrumb" in matched[i].instances.default) {
            ret = ret.concat(matched[i].instances.default.breadcrumb);
          }
        }
      }

      return ret;
    }
  }
}
</script>